import React, { useState } from 'react';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';
import { ArrowRight, CheckCircle2, Loader2 } from 'lucide-react';
// Replace these with actual EmailJS credentials
const EMAILJS_SERVICE_ID = 'YOUR_SERVICE_ID';
const EMAILJS_TEMPLATE_ID = 'YOUR_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY = 'YOUR_PUBLIC_KEY';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      // Uncomment and configure when EmailJS is set up
      /*
      await emailjs.sendForm(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        e.currentTarget,
        EMAILJS_PUBLIC_KEY
      );
      */
      // Simulate API call for now
      await new Promise(resolve => setTimeout(resolve, 1500));
      setIsSuccess(true);
    } catch (err) {
      setError('Hubo un error al enviar el formulario. Por favor, intenta de nuevo o agenda directamente.');
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };
  const inputClasses = 'w-full bg-[#0A0A0A] border border-border rounded-lg px-4 py-3 text-white placeholder:text-neutral-500 focus:outline-none focus:ring-2 focus:ring-gold focus:border-transparent transition-all';
  const labelClasses = 'block text-sm font-medium text-neutral-300 mb-2';
  return <section id="contacto" className="py-20 md:py-28 px-4 bg-carbon relative border-t border-border" data-id="element-1">
      <div className="max-w-4xl mx-auto" data-id="element-2">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-3">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gold tracking-tight mb-4" data-id="element-4">
            Agenda Tu Consulta Estratégica Gratuita
          </h2>
          <p className="text-lg text-neutral-400 max-w-2xl mx-auto" data-id="element-5">
            Completa el formulario y un especialista te contactará en menos de
            24 horas
          </p>
        </motion.div>

        <motion.div className="bg-surface border border-border rounded-2xl p-6 md:p-10 shadow-2xl relative overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} data-id="element-6">
          {isSuccess ? <div className="text-center py-12" data-id="element-7">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            bounce: 0.5
          }} className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald/20 text-emerald mb-6" data-id="element-8">
                <CheckCircle2 className="w-10 h-10" data-id="element-9" />
              </motion.div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-10">
                ¡Gracias! Nos pondremos en contacto contigo pronto.
              </h3>
              <p className="text-neutral-400 mb-8" data-id="element-11">
                Si prefieres no esperar, puedes agendar tu cita directamente en
                nuestro calendario.
              </p>
              <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-gold text-carbon font-bold uppercase tracking-wide px-8 py-4 rounded-lg transition-colors hover:bg-[#F5C736] hover:shadow-gold-glow" data-id="element-12">
                AGENDAR EN EL CALENDARIO AHORA
              </a>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-13">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-14">
                <div data-id="element-15">
                  <label htmlFor="user_name" className={labelClasses} data-id="element-16">
                    Nombre completo *
                  </label>
                  <input type="text" id="user_name" name="user_name" required className={inputClasses} placeholder="Ej. María Pérez" data-id="element-17" />
                </div>
                <div data-id="element-18">
                  <label htmlFor="user_email" className={labelClasses} data-id="element-19">
                    Email *
                  </label>
                  <input type="email" id="user_email" name="user_email" required className={inputClasses} placeholder="maria@tuspa.com" data-id="element-20" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-21">
                <div data-id="element-22">
                  <label htmlFor="user_phone" className={labelClasses} data-id="element-23">
                    Número de teléfono *
                  </label>
                  <input type="tel" id="user_phone" name="user_phone" required className={inputClasses} placeholder="+1 (555) 000-0000" data-id="element-24" />
                </div>
                <div data-id="element-25">
                  <label htmlFor="company_name" className={labelClasses} data-id="element-26">
                    Nombre de tu Spa / Compañía *
                  </label>
                  <input type="text" id="company_name" name="company_name" required className={inputClasses} placeholder="Ej. Bella Spa" data-id="element-27" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-28">
                <div data-id="element-29">
                  <label htmlFor="instagram" className={labelClasses} data-id="element-30">
                    Instagram de tu negocio
                  </label>
                  <input type="text" id="instagram" name="instagram" className={inputClasses} placeholder="@tuspa" data-id="element-31" />
                </div>
                <div data-id="element-32">
                  <label htmlFor="website" className={labelClasses} data-id="element-33">
                    Website
                  </label>
                  <input type="text" id="website" name="website" className={inputClasses} placeholder="www.tuspa.com" data-id="element-34" />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-35">
                <div data-id="element-36">
                  <label htmlFor="current_clients" className={labelClasses} data-id="element-37">
                    ¿Cuántos clientes atiendes por semana? *
                  </label>
                  <select id="current_clients" name="current_clients" required className={inputClasses} data-id="element-38">
                    <option value="" disabled selected data-id="element-39">
                      Selecciona una opción
                    </option>
                    <option value="Menos de 10" data-id="element-40">Menos de 10</option>
                    <option value="10-25" data-id="element-41">10-25</option>
                    <option value="25-50" data-id="element-42">25-50</option>
                    <option value="50-100" data-id="element-43">50-100</option>
                    <option value="Más de 100" data-id="element-44">Más de 100</option>
                  </select>
                </div>
                <div data-id="element-45">
                  <label htmlFor="goal_clients" className={labelClasses} data-id="element-46">
                    ¿Cuál es tu meta semanal de clientes nuevos? *
                  </label>
                  <select id="goal_clients" name="goal_clients" required className={inputClasses} data-id="element-47">
                    <option value="" disabled selected data-id="element-48">
                      Selecciona una opción
                    </option>
                    <option value="5-10" data-id="element-49">5-10</option>
                    <option value="10-20" data-id="element-50">10-20</option>
                    <option value="20-50" data-id="element-51">20-50</option>
                    <option value="Más de 50" data-id="element-52">Más de 50</option>
                  </select>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-53">
                <div data-id="element-54">
                  <label htmlFor="ads_experience" className={labelClasses} data-id="element-55">
                    ¿Has invertido en publicidad digital antes? *
                  </label>
                  <select id="ads_experience" name="ads_experience" required className={inputClasses} data-id="element-56">
                    <option value="" disabled selected data-id="element-57">
                      Selecciona una opción
                    </option>
                    <option value="No nunca" data-id="element-58">No, nunca</option>
                    <option value="Sí pero no funcionó" data-id="element-59">
                      Sí, pero no funcionó
                    </option>
                    <option value="Sí con buenos resultados" data-id="element-60">
                      Sí, con buenos resultados
                    </option>
                    <option value="Sí pero quiero mejorar" data-id="element-61">
                      Sí, pero quiero mejorar
                    </option>
                  </select>
                </div>
                <div data-id="element-62">
                  <label htmlFor="ads_budget" className={labelClasses} data-id="element-63">
                    ¿Cuánto has invertido en publicidad? *
                  </label>
                  <select id="ads_budget" name="ads_budget" required className={inputClasses} data-id="element-64">
                    <option value="" disabled selected data-id="element-65">
                      Selecciona una opción
                    </option>
                    <option value="Nada" data-id="element-66">Nada</option>
                    <option value="Menos de $500/mes" data-id="element-67">Menos de $500/mes</option>
                    <option value="$500-$2,000/mes" data-id="element-68">$500-$2,000/mes</option>
                    <option value="$2,000-$5,000/mes" data-id="element-69">$2,000-$5,000/mes</option>
                    <option value="Más de $5,000/mes" data-id="element-70">Más de $5,000/mes</option>
                  </select>
                </div>
              </div>

              {error && <div className="p-4 bg-red-500/10 border border-red-500/50 rounded-lg text-red-500 text-sm" data-id="element-71">
                  {error}
                </div>}

              <div className="pt-4 flex flex-col items-center gap-4" data-id="element-72">
                <button type="submit" disabled={isSubmitting} className="w-full md:w-auto inline-flex items-center justify-center bg-gold text-carbon font-bold uppercase tracking-wide px-10 py-4 rounded-lg transition-colors hover:bg-[#F5C736] hover:shadow-gold-glow focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-carbon disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-73">
                  {isSubmitting ? <>
                      <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-74" />{' '}
                      ENVIANDO...
                    </> : 'ENVIAR MI INFORMACIÓN'}
                </button>
                <a href="https://calendar.app.google/gDsqAVqmwUYm" target="_blank" rel="noopener noreferrer" className="text-neutral-400 hover:text-gold transition-colors flex items-center gap-2 text-sm font-medium" data-id="element-75">
                  O agenda directamente en nuestro calendario{' '}
                  <ArrowRight className="w-4 h-4" data-id="element-76" />
                </a>
              </div>
            </form>}
        </motion.div>
      </div>
    </section>;
}